// Stripe.js loader shared by the app (Vite) and the marketing site (Next.js),
// which imports the same scheduling modals.

// The pure entry point defers injecting the script until loadStripe() runs;
// the default entry injects it on import.
import { loadStripe } from '@stripe/stripe-js/pure';
import type { Stripe } from '@stripe/stripe-js';
import { getEnv } from './env';

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Load Stripe.js on first use rather than at module import, so a page that
 * merely bundles a scheduling modal does not fetch Stripe or need its key.
 * Resolves null when no publishable key is configured instead of letting
 * loadStripe reject with an uncaught IntegrationError.
 */
export const getStripe = (): Promise<Stripe | null> => {
  if (!stripePromise) {
    const publishableKey = getEnv('STRIPE_PK');
    if (!publishableKey) {
      console.warn('[stripe] No publishable key configured; Stripe is unavailable.');
      stripePromise = Promise.resolve(null);
    } else {
      stripePromise = loadStripe(publishableKey).catch((error) => {
        console.error('[stripe] Failed to load Stripe.js', error);
        stripePromise = null;
        return null;
      });
    }
  }
  return stripePromise;
};

export const resetStripeForTests = (): void => {
  stripePromise = null;
};
